var map = {
	"./en/legal_status.json": [
		24096,
		4096
	],
	"./fr/legal_status.json": [
		29413,
		9413
	],
	"./nl/legal_status.json": [
		95683,
		5683
	],
	"./zh/legal_status.json": [
		93179,
		3179
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 73109;
module.exports = webpackAsyncContext;